import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box } from "@mui/system";
import Button from "@mui/material/Button";
import { currentAssetSliceActions } from "../../../Store/Slices/CurrentAssetSlice";
import { randomNumber, unicodeToString } from "../../../Js/Common";
import { Typography } from "@mui/material";
import ImageIcon from "@mui/icons-material/Image";
import TitleIcon from "@mui/icons-material/Title";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import IconButton from "@mui/material/IconButton";
import AudioButton from "../../../Components/Media/AudioButton";
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
import PauseIcon from "@mui/icons-material/Pause";
import "./style.css";

var initLogObj = {
  attempts: 1,
  duration: 0,
  assetType: {
    group: "presentation",
    value: null,
  },
  userAnswer: [],
  isEvaluated: "auto",
  actualAnswer: [],
  genericScore: 1,
};

const BG = (props) => {
  // Hooks
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const classes = useStyles();

  // State
  const [userAnswer, setUserAnswer] = useState([]);
  const [currentCardAlreadyShow, setCurrentCardAlreadyShow] = useState({
    text: false,
    image: false,
    audio: false,
    video: false,
    article: false,
  });
  const [mainData, setMainData] = useState([]);
  const [cardsToShow, setCardsToShow] = useState([]);
  const [cardsAlredySeen, setCardsAlredySeen] = useState([]);
  const [logObj, setLogObj] = useState(initLogObj);
  const [randomDigit, setRandomDigit] = useState(0);
  const [start, setStart] = useState(false);
  const [flip, setFlip] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);

  // Redux state
  const { showAnswer, assetLogObj, attempted, currentAttempt } = useSelector(
    (state) => state.currentAsset
  );

  useEffect(() => {
    if (props.content) {
      let arr = [];
      for (let x = 0; x < props.content.epage.options.content.length; x++) {
        arr = arr.concat(props.content.epage.options.content[x]["cols"]);
      }
      setCardsToShow(arr);
      setMainData(arr);

      setLogObj({
        ...logObj,
        assetType: {
          ...logObj.assetType,
          value: props.content.info.asset_type_alias,
        },
      });
    }
  }, [props.content]);

  useEffect(() => {
    dispatch(currentAssetSliceActions.setAssetLogObj(logObj));
  }, [logObj]);

  useEffect(() => {
    console.log("cardsToShow", cardsToShow);
  }, [cardsToShow]);

  const getQue = () => {
    if (start) {
      if (cardsToShow.length == 1 && cardsAlredySeen.length > 0) {
        let arr = [...cardsToShow, ...cardsAlredySeen];
        setCardsAlredySeen([]);
        setCardsToShow(mainData);
        setRandomDigit(randomNumber(arr.length - 1));
      } else {
        let arr = [...cardsToShow];
        let arr2 = [...cardsAlredySeen, cardsToShow[randomDigit]];
        setCardsAlredySeen(arr2);
        arr.splice(randomDigit, 1);
        setCardsToShow(arr);
        setRandomDigit(randomNumber(cardsToShow.length - 1));
      }
    }
    setFlip(true);
    document.getElementById("cardId").classList.toggle("is-flipped");
    setTimeout(() => {
      document.getElementById("cardId").classList.toggle("is-flipped");
      setFlip(false);
    }, 1000);
    setStart(true);
  };

  const changeHideFlag = (key) => {
    // let arr = [...cardsToShow];
    // console.log("arr[randomDigit]",arr[randomDigit]["hide"]);
    // arr[randomDigit]["hide"][key] = false;
    setCardsToShow((prevItem) => {
      return prevItem.map((item, i) => {
        if (i == randomDigit) {
          return { ...item, hide: { ...item.hide, [key]: false } };
        } else {
          return item;
        }
      });
    });
  };

  return (
    <Grid item xs={12}>
      <Box
        sx={{
          py: 2,
          mx: 6,
          mt: 1,
          height: "58vh",
        }}
      >
        <Grid
          container
          sx={{
            flexDirection: "row",
            flexFlow: "wrap",
            justifyContent: "center",
            px: 2,
            gap: 3,
            alignItems: "center",
          }}
        >
          <Grid item lg={6} xs={7} sx={{ textAlign: "center" }}>
            <Box
              sx={{
                backgroundColor: "#b8c4de",
                borderRadius: 5,
                transform: "rotate(3deg)",
                height: "50vh",
              }}
              className="scene scene--card"
            >
              <Grid
                sx={{
                  backgroundColor: "#DB8829",
                  height: "50vh",
                  transform: "rotate(-3deg)",
                  borderRadius: 5,
                }}
                className="card"
                id="cardId"
              >
                <div
                  className="card__face card__face--front"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {!flip && (
                    <>
                      {start && (
                        <>
                          {cardsToShow[randomDigit].media?.image &&
                            !cardsToShow[randomDigit].hide?.image && (
                              <Box sx={{ pt: 1 }}>
                                <img
                                  src={`${sessionStorage.getItem(
                                    "media_url"
                                  )}image/${
                                    cardsToShow[randomDigit]["media"]["image"]
                                  }`}
                                  width="80%"
                                  style={{ borderRadius: "20px" }}
                                />
                              </Box>
                            )}
                          {cardsToShow[randomDigit]["text"] &&
                            !cardsToShow[randomDigit].hide?.text && (
                              <Typography
                                sx={{
                                  pt: 3,
                                  px: 2,
                                  fontSize: "1rem",
                                  fontWeight: "600",
                                  color: "#FFFFFF",
                                }}
                              >
                                <span id="que">
                                  {unicodeToString(
                                    cardsToShow[randomDigit]["text"]
                                  )}
                                </span>
                              </Typography>
                            )}
                          <Box sx={{ pt: 3 }}>
                            {cardsToShow[randomDigit].hide?.text &&
                              !cardsToShow[randomDigit].hide?.audio && (
                                <IconButton
                                  sx={{
                                    color: "#DB8829",
                                    backgroundColor: "#FFFFFF",
                                    mx: 1,
                                    padding: 0,
                                   
                                  }}
                                  onClick={() => {
                                    changeHideFlag("text");
                                  }}
                                >
                                  <TitleIcon
                                    sx={{
                                      borderRadius: "50%",
                                      padding: 1,
                                      color: "#DB8829",
                                      "@media (min-width: 1636px)": {
                                        fontSize: "2.2rem",
                                      },
                                    }}
                                  />
                                </IconButton>
                              )}
                            {cardsToShow[randomDigit].hide?.image && (
                              <IconButton
                                sx={{
                                  color: "#DB8829",
                                  backgroundColor: "#FFFFFF",
                                  mx: 1,
                                  padding: 0,
                                 
                                }}
                                onClick={() => {
                                  changeHideFlag("image");
                                }}
                              >
                                <ImageIcon
                                  sx={{
                                    borderRadius: "50%",
                                    padding: 1,
                                    color: "#DB8829",
                                    "@media (min-width: 1636px)": {
                                      fontSize: "2.2rem",
                                    },
                                  }}
                                />
                              </IconButton>
                            )}
                            {cardsToShow[randomDigit]["media"] &&
                              cardsToShow[randomDigit]["media"]["audio"] && (
                                <AudioButton
                                  expertAudio={
                                    cardsToShow[randomDigit]["media"]["audio"]
                                  }
                                  playStatus={(status, isended) => {
                                    setIsPlaying(status);
                                    if (
                                      isended &&
                                      cardsToShow[randomDigit].hide?.audio &&
                                      cardsToShow[randomDigit].hide?.text
                                    ) {
                                      changeHideFlag("text");
                                    }
                                  }}
                                >
                                  <IconButton
                                    sx={{
                                      color: "#DB8829",
                                      backgroundColor: "#FFFFFF",
                                      mx: 1,
                                      padding: 0,
                                     
                                    }}
                                  >
                                    {isPlaying && (
                                      <PauseIcon
                                        sx={{
                                          borderRadius: "50%",
                                          padding: 1,
                                          color: "#DB8829",
                                          "@media (min-width: 1636px)": {
                                            fontSize: "2.2rem",
                                          },
                                        }}
                                      />
                                    )}
                                    {!isPlaying && (
                                      <MusicNoteIcon
                                        sx={{
                                          borderRadius: "50%",
                                          padding: 1,
                                          "@media (min-width: 1636px)": {
                                            fontSize: "2.2rem",
                                          },
                                        }}
                                      />
                                    )}
                                  </IconButton>
                                </AudioButton>
                              )}
                          </Box>
                        </>
                      )}
                      {!start && (
                        <Typography
                          sx={{
                            pt: 3,
                            px: 2,
                            fontSize: "1rem",
                            fontWeight: "600",
                            color: "#FFFFFF",
                          }}
                        >
                          <span>Click On Button</span>
                        </Typography>
                      )}
                    </>
                  )}
                </div>
                <div
                  className="card__face card__face--back"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {/* <img
                    src={require('../../../assets/logo_white.png')}
                    width="80%"
                    style={{ borderRadius: "20px" }}
                  /> */}
                </div>
              </Grid>
            </Box>
          </Grid>
          <Grid item lg={5} xs={4}>
            <Box>
              <Grid
                container
                sx={{
                  flexDirection: "row",
                  mt: 1,
                  borderRadius: 10,
                  boxShadow: 0,
                  cursor: "pointer",
                  py: 2,
                }}
              >
                <Grid item sx={{ ml: {
                  lg: 1,
                  xs: 5
                }, cursor: "pointer" }}>
                  <Button
                    variant="contained"
                    sx={{
                      textTransform: "inherit",
                      borderRadius: 10,
                      boxShadow: 3,
                      fontWeight: "600",
                      fontSize: "1rem",
                    }}
                    onClick={getQue}
                  >
                    {cardsToShow.length == 1 && cardsAlredySeen.length > 0
                      ? "Replay the game ?"
                      : "Get new Question"}
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Grid>
  );
};
const useStyles = makeStyles({
  ListItemText: {
    fontSize: "1rem !important",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default BG;
